import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { AppState } from '../store';
import * as fromRequestCounter from '../store/requestCounter/requestCounter.reducer';

@Injectable()
export class RequestCounterInterceptor implements HttpInterceptor {
  constructor(private store: Store<AppState>) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { headers } = request;
    const uiLoader = (headers.get('ui-loader') || 'true') === 'true';

    if (uiLoader) {
      this.store.dispatch(fromRequestCounter.actions.incrementCounter());
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (uiLoader) {
          this.store.dispatch(fromRequestCounter.actions.decrementCounter());
        }
      }),
      catchError((error: any) => observableThrowError(error)),
    );
  }
}
